import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import countries from './countries'; // Make sure this path is correct


const CountryAutocomplete = ({ userData, setUserData, errors }) => {
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    if (selectedCountry) {
      setUserData((prevData) => ({
        ...prevData,
        userCountry: selectedCountry.code,
      }));
    }
  }, [selectedCountry, setUserData]);

  // Find the country object by code
  const getCountryName = (code) => {
    const country = countries.find((c) => c.code === code);
    return country ? country.label : '';
  };

  return (
    <Autocomplete
      options={countries}
      getOptionLabel={(option) => option.label} // Show country name in the dropdown
      autoHighlight
      onChange={(event, value) => setSelectedCountry(value)}
      value={countries.find((c) => c.code === userData.userCountry) || null} // Set the selected value based on the userCountry code
      renderOption={(props, option) => (
        <li {...props}>
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            className='mx-2'
            alt=""
          />
          {option.label} ({option.code})
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={'User country'}
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.userCountry)}
          helperText={errors.userCountry}
        />
      )}
    />
  );
};

export default CountryAutocomplete;




